import fetch from 'node-fetch';
import { RestLink } from '@famly/tail_apollo-rest-link';
import { billPayerSplitConfigurationTypePatcher } from './rest-types/bill-payer-split-configuration/bill-payer-split-configuration-type-patcher';
import { institutionDataTypePatcher } from './rest-types/institution-data/institution-data-type-patcher';
import { createProductPatcher } from './rest-types/create-product/create-product-type-patcher';
import { downloadAttendanceReportTypePatcher } from './rest-types/download-attendance-report/download-attendance-report-type-patcher';
import { downloadBookingsOrgTypePatcher } from './rest-types/download-bookings-org/download-bookings-org-type-patcher';
import { editPaymentPatcher } from './rest-types/edit-payment/edit-payment-patcher';
import { feedInstitutionsTypePatcher } from './rest-types/feed-institutions/feed-institutions-type-patcher';
import { invoicePatcher } from './rest-types/invoice/invoice-patcher';
import { newGroupPatcher } from './rest-types/new-group/new-group-patcher';
import { parentalPermissionsTypePatcher } from './rest-types/parental-permissions/parental-permissions-type-patcher';
import { parentDocumentTypePatcher } from './rest-types/parent-document/parent-document-type-patcher';
import { parentDocumentAcknowledgementStatusTypePatcher } from './rest-types/parent-document-acknowledgement-status/parent-document-acknowledgement-status-type-patcher';
import { parentDocumentCanCreateTypePatcher } from './rest-types/parent-document-can-create/parent-document-can-create-type-patcher';
import { parentDocumentForChildProfileTypePatcher } from './rest-types/parent-document-for-child-profile/parent-document-for-child-profile-type-patcher';
import { parentPermissionRecipientTypePatcher } from './rest-types/parent-permission-recipient/parent-permission-recipient-type-patcher';
import { paymentMethodPatcher } from './rest-types/payment-method/payment-method-patcher';
import { persistFileTypePatcher } from './rest-types/persist-file/persist-file-type-patcher';
import { searchResultsTypePatcher } from './rest-types/search-results/search-results-type-patcher';
import { unlikeResourceTypePatcher } from './rest-types/unlike-resource/unlike-resource-type-patcher';
import { uploadRequestTypePatcher } from './rest-types/upload-request/upload-request-type-patcher';
import { validateBillingPlanPatcher } from './rest-types/validate-billing-plan/validate-billing-plan-type-patcher';
import { voucherCompanyPatcher } from './rest-types/voucher-company/voucher-company-patcher';
import { organizationOverviewTypePatcher } from './rest-types/organizations/organization-overview-type-patcher';
// There's a type mismatch between `@types/node-fetch` and `RestLinkOptions['customFetch']`
// Since we're only using `node-fetch` for react-testing-library we'll just cast the type.
const typedFetch = fetch;
/**
 * Creates a apollo rest link for the given url.
 *
 * Routes the rest calls handled by graphql apollo to the given url. Also, defines the
 * types and type patcher (adapter) for all defined graphql rest calls.
 *
 * @param uri the uri of the rest endpoints
 * @returns an RestLink with the said properties
 */
export function createRestLink(uri) {
    const isTestingEnvironment = process.env.TEST_TYPE === 'jest';
    return new RestLink({
        uri,
        // A fetcher function is required when React testing library tests are run, if the fetcher function is not found then that will result into a failing test.
        customFetch: isTestingEnvironment ? typedFetch : undefined,
        typePatcher: {
            CreateProduct: createProductPatcher,
            DownloadBookingsOrg: downloadBookingsOrgTypePatcher,
            DownloadChildAttendanceReport: downloadAttendanceReportTypePatcher,
            EditPayment: editPaymentPatcher,
            FeedInstitutions: feedInstitutionsTypePatcher,
            FetchInvoices: invoicePatcher,
            Institution: institutionDataTypePatcher,
            NewGroup: newGroupPatcher,
            OrganizationInstitution: organizationOverviewTypePatcher,
            ParentalPermissions: parentalPermissionsTypePatcher,
            ParentDocument: parentDocumentTypePatcher,
            ParentDocumentAcknowledgementStatusResult: parentDocumentAcknowledgementStatusTypePatcher,
            ParentDocumentCanCreate: parentDocumentCanCreateTypePatcher,
            ParentDocumentForChildProfile: parentDocumentForChildProfileTypePatcher,
            ParentPermissionRecipient: parentPermissionRecipientTypePatcher,
            PaymentMethod: paymentMethodPatcher,
            PersistFile: persistFileTypePatcher,
            SearchResults: searchResultsTypePatcher,
            UnlikeResource: unlikeResourceTypePatcher,
            UpdateBillPayerSplitConfiguration: billPayerSplitConfigurationTypePatcher,
            UploadRequest: uploadRequestTypePatcher,
            ValidateBillingPlan: validateBillingPlanPatcher,
            VoucherCompanyOptions: voucherCompanyPatcher,
        },
    });
}
